import { readClipboard, writeClipboard } from '@solid-primitives/clipboard';
import { useCurrency } from '@bz/common';

import { DEFAULT_LANG } from '~/constants';

export * from './formate';
export * from './const';
export function getThemeDarken() {
  return setting.theme !== 2;
}

/**
 * Format number with thousand separators and optional decimal places
 * @param num - Number to format
 * @param locale - Locale string for formatting
 * @param minimumFractionDigits - Minimum decimal places (default: 0)
 * @param maximumFractionDigits - Maximum decimal places (default: 0)
 */
export function formatNumber(
  num: number | string,
  locale: string = DEFAULT_LANG,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = 0
): string {
  try {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(Number(num));
  } catch {
    return num.toString();
  }
}

/** 复制 */
export function onCopy(text: string) {
  try {
    writeClipboard(text);
    toast.success(t('Copied'));
  } catch {
    toast.error(t('Copy failed'));
  }
}

/** 粘贴 */
export const onPaste = async (onChange: (text: string) => void) => {
  try {
    let text = '';
    const items = await readClipboard();
    for (const item of items) {
      if (item.types.includes('text/plain')) {
        const blob = await item.getType('text/plain');
        text = await blob.text();
      }
    }
    onChange(text);
  } catch {
    toast.error(t('Paste failed'));
  }
};

/** 短订单号 */
export function shortenOrderId(orderId: string = '', tailLength = 4): string {
  if (orderId.length <= tailLength * 2) return orderId;
  const prefix = orderId.slice(0, tailLength);
  const suffix = orderId.slice(-tailLength);
  return `${prefix}...${suffix}`;
}

// 更新icon版本号 暂时先写死，后续可通过接口返回版本，或者根据项目版本号更新
const ICON_VERSION = '2026-04-038';
/** isCash=true 显示国旗icon */
export function getCoinIcon(name: string, isCash = false) {
  const beforeUrl = import.meta.env.VITE_CURRENCY_ICON_URL;
  return isCash
    ? `${beforeUrl}${name}.white.png?v=${ICON_VERSION}`
    : `${beforeUrl}${currencyConfig[name]?.aliasCurrencyName || name}.png?v=${ICON_VERSION}`;
  // return import.meta.env.DEV
  //   ? a`https://prod-wallet.s3.ap-northeast-1.amazonaws.com/wallet-currency-icon/coin_icons/${name}.png`
  //   : `/wallet-currency-icon/coin_icons/${name}.png`;
}

/** 获取币种别名 */
export function getAlias(name?: string) {
  return (name && currencyConfig[name]?.aliasCurrencyName) || name || '';
}

/** 判断是否是法币 */
export function isFiat(name: string) {
  return currencyConfig[name]?.currencyType === 0;
}

/** 判断是否是加密货币 */
export function isCrypto(name: string) {
  return currencyConfig[name]?.currencyType === 1;
}

export function isBonus(paymentMethod: 'BALANCE' | 'BONUS') {
  return paymentMethod === 'BONUS';
}
/** 受顶部优惠券影响的币种余额
 */
export function getCurrencyBalance(currency?: string) {
  const { latestCurrency, isCash } = useCurrency();
  const key = currency || latestCurrency();
  if (isCash()) {
    const balance = currencyRecommend.currencyMap?.[key]?.balance ?? 0;
    return balance;
  }
  return currencyRecommend.bonus?.currencyList?.find((item) => item.currencyCode === key)?.balance ?? 0;
}
export function getCashCurrencyBalance(currency?: string) {
  const { latestCurrency } = useCurrency();
  const key = currency || latestCurrency();
  const balance = currencyRecommend.currencyMap?.[key]?.balance ?? 0;
  return balance;
}
